import React from 'react';

function Spinner(props) {
  return <div className="preload-spinner border-red1-dark" />;
}

export default Spinner;
